import {
  useListModelDependHub,
  useMyHubsList,
} from "hooks/user-profile/useUserProfile";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const ModelDependHubSelect = ({
  isDisabled,
  idModelDefault,
  setValue,
  value,
  fieldName,
  pathModel,
  title,
  isFilterByHubSelect,
  idHubFilterSelect,
  ...props
}) => {
  const { t } = useTranslation(["hub"]);

  const { data: myHubs, refetch: refetchMyHubs } = useMyHubsList(
    {
      queryKey: `my-hub-select`,
      enabled: true,
    },
    res => {}
  );

  const [modelParams, setModelParams] = useState({
    sizePerPage: 10,
    page: -1,
    sort: "-maker_date",
    columnFilter: {
      "filter[record_status]": "O",
    },
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
    run: false,
  });

  const {
    data: dataModel,
    refetch: refetchModel,
    remove,
  } = useListModelDependHub(
    {
      pathModel: pathModel,
      params: modelParams,
      queryKey: `model-depend-select-${fieldName}`,
      enabled: false,
    },
    res => {}
  );

  useEffect(() => {
    if (modelParams && modelParams?.run) {
      refetchModel();
    }
  }, [modelParams]);

  useEffect(() => {
    if (myHubs && !isFilterByHubSelect) {
      const { hub, childs_hub } = myHubs;
      const listHubIdsFilter = [
        hub.id,
        ...childs_hub?.map(h => {
          return h?.id;
        }),
      ];
      if (listHubIdsFilter?.length > 0) {
        setModelParams(prev => {
          return {
            ...prev,
            columnFilter: {
              ...prev.columnFilter,
              "filter[hub_id][in]": listHubIdsFilter,
            },
            run: true,
          };
        });
      }
    }
  }, [myHubs, isFilterByHubSelect]);

  useEffect(() => {
    if (isFilterByHubSelect) {
      console.log("🚀 ~ idHubFilterSelect:", idHubFilterSelect);
      if (idHubFilterSelect) {
        setModelParams(prev => {
          return {
            ...prev,
            columnFilter: {
              ...prev.columnFilter,
              "filter[hub_id]": idHubFilterSelect,
            },
            run: true,
          };
        });
      } else {
        setModelParams(prev => {
          return {
            ...prev,
            columnFilter: {
              ...prev.columnFilter,
              "filter[hub_id]": idHubFilterSelect || -1,
            },
          };
        });
      }
      if (modelParams?.run) {
        setValue(fieldName, null);
      }
    }
  }, [isFilterByHubSelect, idHubFilterSelect]);

  const options = useMemo(() => {
    return (
      dataModel?.items?.map(item => {
        return {
          value: item.id,
          label: item.name,
        };
      }) || []
    );
  }, [dataModel?.items]);

  useEffect(() => {
    return () => {
      remove();
    };
  }, []);

  return (
    <Select
      {...props}
      value={value}
      placeholder={t("placeholder.select", {
        title: title,
      })}
      options={options}
      classNamePrefix="select2-selection"
      isDisabled={isDisabled}
    />
  );
};

export default ModelDependHubSelect;
